"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthColConnectionInEquipmentItem = exports.webGLModalsSource = exports.wallColor = exports.verticalPipeSpacing = exports.valueParamsName = exports.themeSettings = exports.styles = exports.spaseBetweenPipesByColInEquipmentItem = exports.spaseBetweenModelsByCol = exports.spaseBetweenModels = exports.smartValveColors = exports.sizeOfStraightPipePerUnit = exports.sizeOfCurvePipePerUnit = exports.pwhSupConfig = exports.pipesTypes = exports.pipesColor = exports.pipeReg = exports.panelPosition = exports.packagePrefix = exports.packageKey = exports.htgSysConfig = exports.htgHxConfig = exports.htgHsConfig = exports.float = exports.filterList = exports.defaultStartModelPosition = exports.defaultShowModel = exports.defaultPositions = exports.connectCubeWidth = exports.ariaReg = exports.activeCableDirection = exports.TypesConnect = exports.TypesByDep = exports.TypeByDepDefault = exports.ModelWidth = exports.ConnectTo = exports.CameraPerspective = void 0;
var _paulCorePackage = require("paul-core-package");
const {
  ComponentTypes,
  modelsWithVersion
} = _paulCorePackage.constants;
const packageKey = exports.packageKey = 'paul_webgl';
const packagePrefix = exports.packagePrefix = '_P_WEBGL';
const webGLModalsSource = exports.webGLModalsSource = '/webgl/source/models';
const pipesTypes = exports.pipesTypes = {
  chilledWater: 'chilledWater',
  hotWater: 'hotWater',
  circulation: 'circulation',
  heatingFlow: 'heatingFlow',
  heatingReturn: 'heatingReturn',
  disabled: 'disabled'
};
const pipeReg = exports.pipeReg = {
  circulation: /10[1-3]0106/i,
  flow: /10[1-3]01(04|08|11)/i,
  return: /10[1-3]01(05|09|12)/i
};
const ariaReg = exports.ariaReg = [{
  aria: 'Pwh',
  reg: /^(Pwh|Pwc)\w*/i,
  pipes: [{
    reg: pipeReg.circulation,
    pipe: pipesTypes.circulation
  }, {
    reg: pipeReg.return,
    pipe: pipesTypes.chilledWater
  }, {
    reg: pipeReg.flow,
    pipe: pipesTypes.hotWater
  }]
}, {
  aria: 'Htg',
  reg: /^Htg\w*/i,
  pipes: [{
    reg: pipeReg.return,
    pipe: pipesTypes.heatingReturn
  }, {
    reg: pipeReg.flow,
    pipe: pipesTypes.heatingFlow
  }]
}];
const pipesColor = exports.pipesColor = {
  chilledWater: '#8bc78b',
  hotWater: '#e69595',
  circulation: '#cf8ae6',
  heatingFlow: '#d97777',
  heatingReturn: '#7ac5cc',
  default: '#adbacc',
  disabled: '#667085'
};
const wallColor = exports.wallColor = '#fff';
const TypesByDep = exports.TypesByDep = {
  [ComponentTypes.HtgSys]: ComponentTypes.HtgSys,
  [ComponentTypes.HtgSub]: ComponentTypes.HtgSub,
  HtgHsFromHtgSys: "".concat(ComponentTypes.HtgHs, "From").concat(ComponentTypes.HtgSys),
  HtgHsGeneral: "".concat(ComponentTypes.HtgHs, "General"),
  HtgHsFromGeneral: "".concat(ComponentTypes.HtgHs, "FromGeneral"),
  [ComponentTypes.HtgHx]: ComponentTypes.HtgHx,
  [ComponentTypes.HtgPipe]: ComponentTypes.HtgPipe,
  [ComponentTypes.HtgCc]: ComponentTypes.HtgCc,
  [ComponentTypes.PwhSupply]: ComponentTypes.PwhSupply,
  [ComponentTypes.PwhC]: ComponentTypes.PwhC,
  [ComponentTypes.PwhPipe]: ComponentTypes.PwhPipe,
  [ComponentTypes.PwcPoe]: ComponentTypes.PwcPoe
};
const TypeByDepDefault = exports.TypeByDepDefault = {
  [ComponentTypes.HtgPipe]: "".concat(ComponentTypes.HtgPipe, "Default")
};
const TypesConnect = exports.TypesConnect = {
  ConnectFromHtgSysToHtgHsFromHtgSys: "ConnectFrom".concat(TypesByDep.HtgSys, "To").concat(TypesByDep.HtgHsFromHtgSys),
  ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral: "ConnectFrom".concat(TypesByDep.HtgHsFromHtgSys, "To").concat(TypesByDep.HtgHsGeneral),
  ConnectFromHtgHsGeneralToHtgHsFromGeneral: "ConnectFrom".concat(TypesByDep.HtgHsGeneral, "To").concat(TypesByDep.HtgHsFromGeneral),
  ConnectHtgHsToHtgHx: 'ConnectFromHtgHsToHtgHx',
  ConnectHtgCc: "Connect".concat(TypesByDep.HtgCc),
  ConnectFromHtgHxToHtgCc: "ConnectFrom".concat(TypesByDep.HtgHx, "To").concat(TypesByDep.HtgCc),
  ConnectFromHtgCcToPwhSupply: "ConnectFrom".concat(TypesByDep.HtgCc, "To").concat(TypesByDep.PwhSupply),
  ConnectFromPwhSupplyToPwhC: "ConnectFrom".concat(TypesByDep.PwhSupply, "To").concat(TypesByDep.PwhC),
  ConnectFromPwhCToPwhPipe: "ConnectFrom".concat(TypesByDep.PwhC, "To").concat(TypesByDep.PwhPipe)
};
const ConnectTo = exports.ConnectTo = {
  left: 'left',
  right: 'right',
  skipHorizontal: 'skipHorizontal',
  null: 'null'
};
const panelPosition = exports.panelPosition = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
};
const activeCableDirection = exports.activeCableDirection = {
  top: 'top',
  bottom: 'bottom',
  front: 'front',
  horizontal: 'horizontal',
  vertical: 'vertical'
};
const float = exports.float = {
  left: 'left',
  right: 'right',
  center: 'center'
};
const defaultStartModelPosition = exports.defaultStartModelPosition = 0;
const spaseBetweenModelsByCol = exports.spaseBetweenModelsByCol = 55;
const spaseBetweenPipesByColInEquipmentItem = exports.spaseBetweenPipesByColInEquipmentItem = 27.5;
const spaseBetweenModels = exports.spaseBetweenModels = 0.5;
const sizeOfStraightPipePerUnit = exports.sizeOfStraightPipePerUnit = 0.19599999999999998;
const sizeOfCurvePipePerUnit = exports.sizeOfCurvePipePerUnit = 1;
const verticalPipeSpacing = exports.verticalPipeSpacing = 10;
const connectCubeWidth = exports.connectCubeWidth = 0.5;
const widthColConnectionInEquipmentItem = exports.widthColConnectionInEquipmentItem = 8;
const ModelWidth = exports.ModelWidth = {
  [ComponentTypes.HtgSys]: 60,
  [ComponentTypes.HtgSub]: 60,
  [ComponentTypes.HtgHs]: 50.5,
  [ComponentTypes.HtgHx]: 50.5 + widthColConnectionInEquipmentItem,
  [ComponentTypes.HtgPipe]: 16.7,
  [ComponentTypes.HtgCc]: 45.5,
  [ComponentTypes.PwhSupply]: 45.5,
  [ComponentTypes.PwhC]: 23.5,
  [ComponentTypes.PwhPipe]: 14,
  [ComponentTypes.PwcPoe]: 0,
  connector: 12.5
};
const defaultShowModel = exports.defaultShowModel = {
  [TypesConnect.ConnectFromHtgCcToPwhSupply]: false,
  [TypesByDep.PwhSupply]: false,
  [TypesByDep.PwcPoe]: false,
  [TypesConnect.ConnectFromPwhSupplyToPwhC]: false,
  [TypesByDep.PwhC]: false,
  [TypesConnect.ConnectFromPwhCToPwhPipe]: false,
  [TypesByDep.PwhPipe]: false,
  [TypesByDep.HtgCc]: false,
  [TypesConnect.ConnectHtgCc]: false,
  [TypesConnect.ConnectFromHtgHxToHtgCc]: false,
  [TypesByDep.HtgPipe]: false,
  [TypesByDep.HtgHx]: true,
  [TypesByDep.HtgHsFromGeneral]: true,
  [TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral]: true,
  [TypesConnect.ConnectHtgHsToHtgHx]: true,
  [TypesByDep.HtgHsGeneral]: true,
  [TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral]: true,
  [TypesByDep.HtgHsFromHtgSys]: true,
  [TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys]: true,
  [TypesByDep.HtgSys]: true,
  [TypesByDep.HtgSub]: true
};
const defaultPositions = exports.defaultPositions = {
  [TypesByDep.PwcPoe]: [0, 0, -25.5],
  [TypesByDep.PwhPipe]: [-spaseBetweenModelsByCol, 0, -10],
  [TypesConnect.ConnectFromPwhCToPwhPipe]: [-spaseBetweenModelsByCol, 0, -10],
  [TypesByDep.PwhC]: [-spaseBetweenModelsByCol, 0, 1],
  [TypesConnect.ConnectFromPwhSupplyToPwhC]: [0, 0, 10],
  [TypesByDep.PwhSupply]: [0, 0, 20],
  [TypesConnect.ConnectFromHtgCcToPwhSupply]: [0, 0, 30],
  [TypesByDep.HtgCc]: [0, 0, 10],
  [TypesConnect.ConnectHtgCc]: [0, 0, -23],
  [TypesConnect.ConnectFromHtgHxToHtgCc]: [0, 0, -29],
  [TypesByDep.HtgHx]: [0, 0, -30],
  [TypesByDep.HtgPipe]: [0, 0, -25],
  [TypesByDep.HtgHsFromGeneral]: [0, 0, -35],
  [TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral]: [0, 0, -86],
  [TypesConnect.ConnectHtgHsToHtgHx]: [0, 0, -86],
  [TypesByDep.HtgHsGeneral]: [0, 0, -92],
  [TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral]: [0, 0, -143],
  [TypesByDep.HtgHsFromHtgSys]: [0, 0, -149],
  [TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys]: [0, 0, -198],
  [TypesByDep.HtgSys]: [0, 0, -205],
  [TypesByDep.HtgSub]: [0, 0, -205]
};
const CameraPerspective = exports.CameraPerspective = {
  TwoD: '2D',
  ThreeD: '3D'
};
const filterList = exports.filterList = [{
  id: 0,
  translationKey: 2,
  key: pipesTypes.chilledWater
}, {
  id: 1,
  translationKey: 3,
  key: pipesTypes.hotWater
}, {
  id: 2,
  translationKey: 4,
  key: pipesTypes.circulation
}, {
  id: 3,
  translationKey: 5,
  key: pipesTypes.heatingFlow
}, {
  id: 4,
  translationKey: 6,
  key: pipesTypes.heatingReturn
}];
const themeSettings = exports.themeSettings = {
  [_paulCorePackage.constants.themeKey.light]: {
    planeColor: '#ebebf5',
    backgroundColor: '#f3f4fd',
    ambientLight: {
      color: '#e5e5e5',
      intensity: 0.3
    },
    hemisphereLight: {
      color: '#FFFFFF',
      intensity: 0.75,
      groundColor: '#5d94c7',
      position: [0, 200, 0]
    },
    directionalLight: {
      color: '#d5d9e3',
      intensity: 0.2,
      position: [130, 180, 50],
      castShadow: true,
      'shadow-bias': 0.0,
      'shadow-mapSize': [1024 * 2, 1024 * 2],
      'shadow-camera-near': 1,
      'shadow-camera-far': 5000,
      'shadow-camera-left': -500,
      'shadow-camera-right': 500,
      'shadow-camera-top': 500,
      'shadow-camera-bottom': -500
    }
  },
  [_paulCorePackage.constants.themeKey.dark]: {
    planeColor: '#003',
    backgroundColor: '#003',
    ambientLight: {
      color: '#5e8bab',
      intensity: 0.45
    },
    hemisphereLight: {
      color: '#dfe1e2',
      intensity: 0.8,
      groundColor: '#8e8696',
      position: [40, 290, 390]
    },
    directionalLight: {
      color: '#a6a6cb',
      intensity: 0.5,
      position: [130, 180, 50],
      castShadow: true,
      'shadow-bias': 0.0,
      'shadow-mapSize': [1024 * 2, 1024 * 2],
      'shadow-camera-near': 1,
      'shadow-camera-far': 5000,
      'shadow-camera-left': -500,
      'shadow-camera-right': 500,
      'shadow-camera-top': 500,
      'shadow-camera-bottom': -500
    }
  }
};
const smartValveColors = exports.smartValveColors = {
  [modelsWithVersion.smartValve_v1_v2_v3]: '#ff9b05',
  [modelsWithVersion.smartValve_v4_v5]: '#006BFF'
};

/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
const styles = exports.styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  boxShadow: {
    primary: '0 5px 15px rgb(0 0 0 / 10%)',
    secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  },
  textCrop: function textCrop() {
    let lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return {
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: lines
    };
  }
};

/**
 @todo: move to core valueParamsName
 **/
const valueParamsName = exports.valueParamsName = {
  value: 'value',
  valueType: 'valueType',
  temperatureStatus: 'temperatureStatus',
  unit: 'unit'
};
const pwhSupConfig = exports.pwhSupConfig = {
  hotWater: 1,
  storeCharging: 3,
  freshWater: 2
};
const htgHsConfig = exports.htgHsConfig = {
  bufferStorage: 3,
  hydraulicSwitch: 1,
  heatExchanger: 2,
  N_A: 4
};
const htgSysConfig = exports.htgSysConfig = {
  renewableSolar: {
    htgSysGeneratorKey: 3,
    htgSysSourceKey: [11],
    htgSysTypeKey: null
  },
  districtHeatingDirect: {
    htgSysGeneratorKey: 2,
    htgSysSourceKey: [12, 13],
    htgSysTypeKey: 2
  },
  districtHeatingIndirect: {
    htgSysGeneratorKey: 2,
    htgSysSourceKey: [12, 13],
    htgSysTypeKey: 1
  },
  renewableHeating: {
    htgSysGeneratorKey: 3,
    htgSysSourceKey: [2, 1, 7, 5, 6],
    htgSysTypeKey: null
  },
  renewableDistrictHeating: {
    htgSysGeneratorKey: 1,
    htgSysSourceKey: [2, 1, 3, 4, 7, 5, 6],
    htgSysTypeKey: null
  },
  renewableAirHeatPump: {
    htgSysGeneratorKey: 3,
    htgSysSourceKey: [8],
    htgSysTypeKey: null
  },
  renewableWaterHeatPump: {
    htgSysGeneratorKey: 3,
    htgSysSourceKey: [10],
    htgSysTypeKey: null
  },
  renewableBrineHeatPump: {
    htgSysGeneratorKey: 3,
    htgSysSourceKey: [9],
    htgSysTypeKey: null
  }
};
const htgHxConfig = exports.htgHxConfig = {
  mixingCircuit: 1,
  mixingCircuitWithFixedBypass: 2,
  throttleCircuit: 3,
  deflectionAndDistributionCircuit: 4,
  injectionCircuitWithGlobalValve: 5,
  injectionCircuitWith3wayValve: 6
};